import { STEPS } from '~/Components/PlanQuiz/_quizConstants'

const UPDATE_ANSWERS = 'UPDATE_ANSWERS'
const UPDATE_CURRENT_STEP = 'UPDATE_CURRENT_STEP'
const UPDATE_BREADCRUMBS = 'UPDATE_BREADCRUMBS'

const INIT_ANSWERS = {
  // common questions
  height: null,
  weight: null,
  smoking: null,
  alcohol: null,
  sugar: null,
  diabetes: null,
  oncological: null,
  infarction: null,
  joints: null,
  reasonsForTest: [],
  running: null,
  runningDistance: null,

  // extended questions
  issues: [],
  issuesStomach: [],
  issuesHearth: [],
  issuesSkin: [],
  issuesOther: []
}

export default {
  namespaced: true,

  state: {
    answers: INIT_ANSWERS,
    currentStep: 0, // 0 for intro step
    breadcrumbs: []
  },

  mutations: {
    [UPDATE_ANSWERS](state, value) {
      state.answers = { ...state.answers, ...value }
    },
    [UPDATE_CURRENT_STEP](state, value) {
      state.currentStep = value
    },
    [UPDATE_BREADCRUMBS](state, value) {
      state.breadcrumbs = value
    }
  },

  getters: {
    getAnswers: (state) => state.answers,
    getAnswerByKey: (state) => (key) => {
      if (!(key in state.answers)) return null

      return state.answers[key]
    },
    getCurrentStep: (state) => {
      return state.currentStep
    },
    getCurrentComponent: (state) => {
      return STEPS[state.currentStep]
    },
    getBreadcrumbs: (state) => state.breadcrumbs
  },

  actions: {
    updateAnswers({ commit }, value) {
      commit(UPDATE_ANSWERS, value)
    },
    updateCurrentStep({ commit }, value) {
      commit(UPDATE_CURRENT_STEP, value)
    },
    updateBreadcrumbs({ commit }, value) {
      commit(UPDATE_BREADCRUMBS, value)
    }
  }
}
